import { ReactNode, useRef, useState } from "react";
import { Drawer, DrawerRef } from "../../drawer";
import { MenuIcon } from "../../icons/MenuIcon";
import { ButtonIcon } from "../../link/ButtonIcon";
import {
  logoContainer,
  menuButtonContainer,
  titleContainer,
  topPanel,
  topPanelContainer,
} from "./styles.css";
import { NavigationPanel } from "../../navigation-menu";
import { Location } from "../../../../providers/routing/types";
import {
  ABOUT_US_PAGE,
  ADVANCED_TECHNOLOGY_PAGE,
  CUSTOM_DESIGN_PAGE,
  CUTTING_COSTS_PAGE,
  SUSTAINABILITY_PAGE,
} from "../../../../providers/routing/routes";
import { LogoButton } from "./LogoButton";

const getCurrentLocation = (): Location => {
  if (typeof window === "undefined") return "main";

  switch (window.location.pathname) {
    case ADVANCED_TECHNOLOGY_PAGE:
      return "inner-technology";
    case CUSTOM_DESIGN_PAGE:
      return "inner-custom-design";
    case SUSTAINABILITY_PAGE:
      return "inner-sustainability";
    case CUTTING_COSTS_PAGE:
      return "inner-cutting-costs";
    case ABOUT_US_PAGE:
      return "inner-about-us";

    default:
      return (window.location.hash.slice(1) || "main") as Location;
  }
};

export const TopPanel = ({
  sticky,
  title,
}: {
  sticky?: boolean;
  title?: ReactNode;
}) => {
  const drawerRef = useRef<DrawerRef>(null);
  const [isOpen, setIsOpen] = useState(() => drawerRef.current?.isOpen());

  const currentLocation = getCurrentLocation();

  const handleDrawerOpen = () => {
    drawerRef.current?.open();
    setIsOpen(true);
  };

  const handleDrawerClose = () => {
    drawerRef.current?.close();
    setIsOpen(false);
  };

  const toggleDrawer = () => {
    drawerRef.current?.isOpen() ? handleDrawerClose() : handleDrawerOpen();
  };

  const handleNavigate = () => {
    handleDrawerClose();
  };

  const panelVariant = sticky ? "sticky" : "fixed";

  return (
    <>
      <Drawer drawerRef={drawerRef}>
        <NavigationPanel
          onNavigate={handleNavigate}
          currentLocation={currentLocation}
        />
      </Drawer>
      <div id="__top-panel" className={topPanelContainer[panelVariant]}>
        <div className={topPanel}>
          <div className={logoContainer}>
            <LogoButton onClick={handleNavigate} />
          </div>
          <div className={titleContainer}>{title}</div>
          <div className={menuButtonContainer}>
            <ButtonIcon onClick={toggleDrawer} primary>
              <MenuIcon isTransformed={isOpen} />
            </ButtonIcon>
          </div>
        </div>
      </div>
    </>
  );
};
